import * as React from "react";
import Wait from "./wait";

export default class PopBig extends React.Component{

    static self = null
    constructor(props) {
        super(props)

        PopBig.self = this

        this.state = {
            title:'Loading...',
            current_pane:<div>Loading...</div>,
        }
    }

    static height = 80
    static show(title_,pane,height=80){
        PopBig.height = height
        PopBig.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail2').style.display='inherit'
        document.getElementById('div-body').style.height=PopBig.height+'vh'
    }

    static width = 100
    static showDynamic(title_,pane,height=80, width=100){
        PopBig.height = height
        PopBig.width = width
        PopBig.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail2').style.display='inherit'
        document.getElementById('div-body').style.height=PopBig.height+'vh'
        document.getElementById('div-outer').style.width=PopBig.width+'vw'
        document.getElementById('div-title').style.textAlign='centre'
    }


    static confirm(title_,description,handler,id,noHandler,height=0){
        if(height===0){
            PopBig.height = 23
        }else{
            PopBig.height = height
        }


        let pane = <div style={{textAlign:'center',padding:'16px'}}>
            <h4>{description}</h4>
            <hr/>
            <button onClick={()=>handler(id)} className={'submit'}>Yes</button>
            <button onClick={()=>noHandler()}>No</button>
        </div>
        PopBig.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail2').style.display='inherit'
        document.getElementById('div-body').style.height=PopBig.height+'vh'
    }


    static showReason(title_,description,handler,action,height=0){
        if(height===0){
            PopBig.height = 23
        }else{
            PopBig.height = height
        }


        let pane = <div style={{textAlign:'center',padding:'16px'}}>
            <h4>{description}</h4>
            <hr/>
            <input type={'text'} style={{width: '99%', padding: '8px'}} name={'reason'}/>
            <button onClick={()=>handler(action)} className={'submit'}>Submit</button>
        </div>
        PopBig.self.setState({
            title:title_,
            current_pane: pane
        })

        document.getElementById('pop_detail2').style.display='inherit'
        document.getElementById('div-body').style.height=PopBig.height+'vh'
    }

    static dismiss(){
        PopBig.self.setState({
            title:'loading.....',
            current_pane:<div>Loading...</div>
        })
        PopBig.self.state = null
        document.getElementById('pop_detail2').style.display='none'
    }

    static download(path){
        Wait.show('Downloading....')
        const link = document.createElement('a');
        link.href = path;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        Wait.dismiss()


    }

    render() {
        return(<div id={'pop_detail2'} style={{verticalAlign:'middle',background:'#fff',zIndex:1001,display:'none',position:'absolute',
            backgroundColor:'#fffa',top:0,bottom:0,left:0,right:0,textAlign:'center'}}>
            <div style={{height:'100vh',textAlign:'center',width:'100vw'}}>
                <div className={'row'}>
                        <div  id={'div-outer'}
                             style={{backgroundColor:'#fff',margin:'10px 2%',width:'96%',padding:0,border:'2px solid #fff',boxShadow:'0 0 100px #888'}}>

                            <div style={{textAlign:'left',width:'100%',top:0,right:0,bottom:0,left:'50px',float:'left'}}>
                                <div id={'div-title'} className={'col col-sm-12'} style={{paddingRight:0,color:'#fff',width:'100%',lineHeight:'40px',height:'40px',
                                    /*backgroundColor:'darkcyan',*/
                                    backgroundColor:'lightslategray'}}>

                                    <span onClick={()=>PopBig.dismiss()} className={'fa fa-times-circle'}
                                      style={{color:'#fff',cursor:'pointer',fontSize:'20px',margin:'8px 24px 0 24px'}}/>

                                    <span style={{marginTop:'16px',fontWeight:'bold'}}>
                                        {this.state.title}
                                    </span>

                                </div>
                                <div style={{height:'94%',
                                    overflowY:'auto', padding:'16px',
                                   /* backgroundColor:'#fff',*/
                                    overflowX:'auto'}}>
                                    {this.state.current_pane}
                                </div>
                            </div>


                        </div>
                    </div>
            </div>
        </div>)
    }
}